<!-- 项目文件 -->
<template>
    <div class="  bgfff">
        <div class="baee">
            <div class="pt16 pb16 bgf6">
                <p class="textindent fs16 c000">报名登记</p>
            </div>
            <div class="pl16 pr16 pb16">
                <ul class="pt10 pb5">
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w14 h16" src="../../public/img/img75.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" v-model="Name" type="text"
                            placeholder="请输入姓名">
                    </li>
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w12 h16" src="../../public/img/img76.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" v-model="Phone" type="text"
                            placeholder="请输入手机号">
                    </li>
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w12 h14" src="../../public/img/img77.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" type="text" v-model="Code"
                            placeholder="请输入验证码">
                        <div class="posab right8 top0 h40 alit" v-show="show" @click="getCode">
                            <span class="pt4 pb4 pl10 pr10 bgeaf disinblock    c1f8 fs12 bradius5  cursor">
                                获取验证码
                            </span>
                        </div>
                        <div class="posab right8 top0 h40 alit" v-show="!show">
                            <span class="pt4 pb4 pl10 pr10 bgeaf disinblock    c1f8 fs12 bradius5  cursor">
                                {{count}} s
                            </span>
                        </div>
                    </li>
                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h38 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w16 h14" src="../../public/img/img78.png"></i>
                        </span>

                        <select class="w100p baee h40 outline textindent3 fs14 c999" v-model="Class" >
                            <option value="" disabled selected hidden>请选择班型</option>
                            <option v-for="(item,index) in OrderType" :key="index" :value='item' @change="changeProduct(item.class_name)" class="pb5 pt5 h50">
                                {{item.class_name}}
                            </option>
                        </select>
                    </li>

                    <li class="mt8 mb8 posre">
                        <span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
                            <i class="w100p textc"><img class="w16 h16" src="../../public/img/img79.png"></i>
                        </span>
                        <input class="w100p baee h40 outline textindent3 fs14 c999" type="text" v-model="Address">
                    </li>

                </ul>
                <div @click="Submit(Area_id)" class="cf16 fbold cfff bg1f8 textc pt10 pb10 bradius5">提 交</div>
            </div>
        </div>


        <div class="baee mt20">
            <div class="pt16 pb16 bgf6">
                <p class="textindent fs16 c000">APP下载二维码</p>
            </div>
            <div class="pl16 pr16 pb16 textc pt16">
                <img class="w200 h200" src="../../public/img/ma.png">
                <p class="fs15 c333">扫一扫 立即下载e学e驾App</p>
            </div>
        </div>
        
    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        props: ['OrderType', 'Area_id'],

        data() {
            return {
                show: true,
                count: '',
                timer: null,
                Name: '',
                Phone: '',
                Code: '',
                Class: '',
                Address: '',
            };
        },
        methods: {
            getCode() { //验证码
                let that = this;
                if (!(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    alert('请正确输入手机号');
                    return 0;
                } else {
                    const TIME_COUNT = 60;
                    if (!this.timer) {
                        this.count = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= TIME_COUNT) {
                                this.count--;
                            } else {
                                this.show = true;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                    $.ajax({
                        type: "POST",
                        url: that.beseAjax + "/school/sendSmsCode.do",
                        dataType: "json",
                        async: false,
                        data: {
                            "phone": that.Phone,
                            "type": 'login'
                        },
                        success: function(data) {
                            console.log(data)
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }

            },
            changeProduct(event) {
                console.log(event)
                this.Class = event.target.value; //获取班型对应的value值
            },
            //高德获取区域
            getLocation() {
                const self = this;
                AMap.plugin("AMap.Geolocation", function() {
                    var geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,
                        timeout: 10000,
                    });
                    geolocation.getCurrentPosition();
                    AMap.event.addListener(geolocation, "complete", onComplete);
                    AMap.event.addListener(geolocation, "error", onError);

                    function onComplete(data) {
                        let province = data.addressComponent.province;
                        let city = data.addressComponent.city;
                        let district = data.addressComponent.district;
                        let street = data.addressComponent.street;
                        self.lng = data.position.lng;
                        self.lat = data.position.lat;
                        self.Address = province + city + district + street;


                        const {
                            position
                        } = data;
                    }

                    function onError(data) {
                        console.log("定位失败错误：", data);
                        self.getLngLatLocation();
                    }
                });
            },
            getLngLatLocation() {
                AMap.plugin("AMap.CitySearch", function() {
                    var citySearch = new AMap.CitySearch();
                    citySearch.getLocalCity(function(status, result) {
                        console.log(status, JSON.stringify(result));
                        if (status === "complete" && result.info === "OK") {
                            // 查询成功，result即为当前所在城市信息
                            console.log("通过ip获取当前城市：", result);
                            //逆向地理编码
                            AMap.plugin("AMap.Geocoder", function() {
                                var geocoder = new AMap.Geocoder({
                                    // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                                    city: result.adcode,
                                });

                                var lnglat = result.rectangle.split(";")[0].split(",");
                                geocoder.getAddress(lnglat, function(status, data) {
                                    if (status === "complete" && data.info === "OK") {
                                        // result为对应的地理位置详细信息
                                        console.log(data);
                                    }
                                });
                            });
                        }
                    });
                });
            },
            //提交表单
            Submit(Area_id) {
                let that = this;
                if (that.Name == "" || !(/^1[23456789]\d{9}$/.test(that.Phone)) || that.Address == "" || that.Code == "" || that.Class == "") {
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseAjax + '/school/bmdj.do',
                        dataType: "json",
                        async: false,
                        data: {
                            "phone": that.Phone,
                            "name": that.Name,
                            "code": that.Code,
                            "address": that.Address,
                            "class_type": that.Class,
                            "area_id": Area_id,
                            "area_name": "",
                            "school_id": ""
                        },
                        success: function(data) {
                            if (data.code == "0") {
                                alert('提交成功')
                            } else {
                                alert(data.info);
                            }
                        },
                        error: function(data) {
                            alert("网络异常，请稍后重试！");
                        }
                    });
                }
            },

        },
        created() {
            this.getLocation();
            console.log('------')
            console.log(this.OrderType)
        },
        mounted() {

        },
    }
</script>
<style scoped>
    select {
        background: none;
    }
</style>